import { axios } from '@/plugins/axios'

export default class RespetoPrincipiosApiRepository {
  async getById(idPersonal, idEvaluacion) {
    try {
      const { data } = await axios.get(
        `/PoliciaCuadrantes/DesarrolloPolicial/personal/${idPersonal}/respetoprincipios/${idEvaluacion}`
      )
      return data
    } catch (error) {
      throw new Error(`Failed to retrieve respetoprincipios: ${error.message}`)
    }
  }

  async create(payload) {
    try {
      const { data } = await axios.post(
        `/PoliciaCuadrantes/DesarrolloPolicial/personal/${payload.fk_idPersonalEvaluado}/respetoprincipios`,
        payload
      )
      return data
    } catch (error) {
      throw new Error(`Failed to create respetoprincipios: ${error.message}`)
    }
  }

  async update(idPersonal, idEvaluacion, payload) {
    try {
      const { data } = await axios.put(
        `/PoliciaCuadrantes/DesarrolloPolicial/personal/${idPersonal}/respetoprincipios/${idEvaluacion}`,
        payload
      )
      return data
    } catch (error) {
      throw new Error(`Failed to update respetoprincipios: ${error.message}`)
    }
  }

  async updateStatus(idPersonal, idEvaluacion, payload) {
    try {
      const { data } = await axios.put(
        `/PoliciaCuadrantes/DesarrolloPolicial/personal/${idPersonal}/respetoprincipios/${idEvaluacion}`,
        payload
      )
      return data
    } catch (error) {
      throw new Error(`Failed to update status of respetoprincipios: ${error.message}`)
    }
  }

  async getEvaluationItems() {
    try {
      const { data } = await axios.get('/PoliciaCuadrantes/DesarrolloPolicial/reactivoPrincipio')
      return data.data
    } catch (error) {
      throw new Error(`Failed to et evaluation items of respetoprincipios: ${error.message}`)
    }
  }
}
